<template>
  <v-row no-gutters>
    <feature-card-basic ref="featureCard" @update:feature="setFeature" :layer="layer">
      <template #top v-if="measurementsVisible">
        <scada-measurements
          style="width: 23vw"
          class="mt-5"
          :feature-id="currentFeatureId"
          :attributes="numericScadaDataSourceAttributes"
          @refreshObjectCard="refreshObjectCard"
        />
      </template>
    </feature-card-basic>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import FeatureCardBasic from '@/components/FeatureCardBasic';
import ScadaMeasurements from '@/components/ScadaMeasurements';
export default {
  name: 'FeatureCardScada',
  components: { FeatureCardBasic, ScadaMeasurements },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    dataSourceSettingsName: get('admin/modulesMapping@scada.selected_datasource_name'),
    isAdminEnabled: get('admin/settingsValues@scada_module_enabled'),
    isSuperAdminEnabled: get('admin/additionalModules@SCADA.enabled'),
    modulesPermissions: get('users/toolsPermissions'),
    scadaDataSourceName: get('admin/modulesMapping@scada.datasource_name'),
    scadaDataSourceAttributes() {
      return this.dataSources?.[this.scadaDataSourceName]?.attributes_schema.attributes || [];
    },
    numericScadaDataSourceAttributes() {
      return this.scadaDataSourceAttributes.filter(
        attribute => ['integer', 'float', 'decimal'].includes(attribute.data_type.name) && !attribute.read_only
      );
    },
    currentFeatureId() {
      return this.$route.params.fid;
    },
    isNew() {
      return this.currentFeatureId === 'new';
    },
    measurementsVisible() {
      return (
        this.isSuperAdminEnabled && this.isAdminEnabled && !this.isNew && this.permissions.preview && this.configurated
      );
    },
    permissions() {
      const value = this.modulesPermissions['SCADA'].main_value;
      return {
        edit: value > 1,
        preview: value > 0,
        value,
      };
    },
  },
  data: () => ({
    configurated: false,
    measurementIdColumn: '',
    systemTypeColumn: '',
  }),
  methods: {
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    async init() {
      const r = await this.getDatasourceSettings(this.dataSourceSettingsName);
      const { measurement_id_column, system_type_column } = r.settings;
      if (measurement_id_column && system_type_column) {
        this.systemTypeColumn = system_type_column;
        this.measurementIdColumn = measurement_id_column;
      }
      return;
    },
    refreshObjectCard() {
      this.$refs.featureCard.updateAfterEdit();
    },
    setFeature(feature) {
      this.configurated = false;
      const measurementIdValue = feature.properties[this.measurementIdColumn];
      const systemTypeValue = this.systemTypeColumn;
      if (measurementIdValue && systemTypeValue) {
        this.configurated = true;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
